export default "__VITE_PUBLIC_ASSET__566e78f7__"